(function() {
  document.addEventListener("DOMContentLoaded", function() {
    const toggleBtn = document.querySelector(".popular-categories .toggle-btn");
    const hiddenCategories = document.querySelectorAll(".popular-categories .hidden-category");
    let isExpanded = false;

    if (toggleBtn && hiddenCategories.length > 0) {
      toggleBtn.addEventListener("click", function() {
        hiddenCategories.forEach(category => {
          category.style.display = isExpanded ? "none" : "block";
        });
        
        toggleBtn.textContent = isExpanded ? "Show More" : "Show Less";
        isExpanded = !isExpanded;
      });
    }
  });
})();